<myclubrewards-header></myclubrewards-header>
<div id="route" class="router">
  <router-outlet></router-outlet>
</div>
<myclubrewards-footer></myclubrewards-footer>
